import {get, ref, serverTimestamp, set} from "firebase/database";
import cfgService from "./cfgService";
import {database} from "../utils/firebase";
import {ADMIN_CONFIG_PATHS} from "../config/adminConfig";
import {lc_system_cfg} from "clicker-common/src/staticData/lc_systemCfg";

const SYSTEM_CONFIG_PATH = ADMIN_CONFIG_PATHS.runtime;

const systemConfigService = {
  async loadSystemConfig() {
    const snapshot = await get(ref(database, SYSTEM_CONFIG_PATH));
    if (snapshot.exists()) {
      return snapshot.val();
    }
    const response = await cfgService.getPublicSystemCfg();
    if (response?.data?.cfg) {
      return {
        uid: response.data.uid,
        cfg: response.data.cfg,
      };
    }
    return {
      uid: null,
      cfg: lc_system_cfg.cfg,
    };
  },

  async saveSystemConfig(uid, cfg) {
    const payload = {
      uid,
      cfg,
      updatedAt: serverTimestamp(),
      updatedBy: uid,
    };
    await set(ref(database, SYSTEM_CONFIG_PATH), payload);
    return payload;
  },
};

export default systemConfigService;
